export const HIGHLIGHT_ANIMATION_TIME = 600;
export const HIGHLIGHT_ANIMATION_DELAY = 1000;
export const HIGHLIGHT_ANIMATION_REMOVE_DELAY = 4000;
export const HIGHLIGHT_ANIMATION_BACKGROUND_COLOR = "rgba(184, 204, 254, 0.4)";
